export default __webpack_public_path__ + "static/media/main_bg_pentagon3.ab99c112.svg";